import React, { useEffect, useState, Fragment } from 'react'
import { useDispatch } from 'react-redux'

import css from './Nav.module.scss'
import { Link } from 'react-router-dom'
import { logoutUser } from '../../../../redux/actions'

const Nav = ({ me }) => {
  const dispatch = useDispatch()
  const [showMenu, setShowMenu] = useState(false)

  useEffect(() => {
    const listener = document.addEventListener('click', (e) => {
      const parent = e.target.parentElement
      if (!showMenu) return
      if (
        e.target?.className?.toLowerCase()?.startsWith('nav') ||
        parent?.className?.toLowerCase()?.startsWith('nav')
      )
        return
      setTimeout(() => {
        setShowMenu(false)
      }, 10)
    })
    return () => document.removeEventListener('click', listener)
  }, [showMenu])

  const logoutHandler = () => {
    setShowMenu(false)
    dispatch(logoutUser())
  }

  if (!me) return null

  return (
    <Fragment>
      <nav className={css.Nav}>
        <button
          className={css.User}
          onClick={() => setShowMenu(!showMenu)}
          aria-label='Profile'
        >
          <img src={me.photoURL} alt='profile' className={css.Avatar} />
        </button>
      </nav>

      {showMenu && (
        <div className={css.Menu}>
          <div className={css.Me}>
            {me.displayName}
            <p>{me.email}</p>
          </div>
          <ul className={css.UlLinks}>
            {/* <li>
              <Link
                to='/settings'
                className={css.Link}
                onClick={() => setShowMenu(false)}
              >
                <i className='fa-solid fa-gears'></i>
                Settings
              </Link>
            </li> */}
            <li>
              <button className={css.Link} onClick={logoutHandler}>
                <i className='fa-solid fa-right-from-bracket'></i> Logout
              </button>
            </li>
          </ul>
        </div>
      )}
    </Fragment>
  )
}

export default Nav
